// Supabase client singleton. Null when unconfigured (e.g. a static build with
// no env) so the UI can render its unauthenticated surfaces without crashing.

import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "./env.ts";

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (client) return client;
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return null;
  client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // Implicit flow returns tokens directly in the URL fragment on redirect.
      // PKCE (the default) instead stores a `code_verifier` in localStorage
      // before redirecting and reads it back to exchange the code — and iOS
      // Safari's storage timing can lose that verifier, dropping users back on
      // the landing page. Implicit has no verifier to lose, so it's robust
      // across the OAuth redirect. Paired with the /auth/callback grace period.
      flowType: "implicit",
    },
  });
  return client;
}

export function isSupabaseConfigured(): boolean {
  return !!(SUPABASE_URL && SUPABASE_ANON_KEY);
}
